var Observable = /** @class */ (function () {
    function Observable() {
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        this.observers.push(f);
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());
export { Observable };
//# sourceMappingURL=observable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-core/esm/tools/observable.js
// module id = ocVN
// module chunks = 1